import { TicketApplicationBaseInfoProps } from '.';

export const defaultTicketApplicationBaseInfo: TicketApplicationBaseInfoProps = {
  orderHash: '',
  orderDetails: [],
  productDetails: [],
};

export const blankTicketApplicationBaseInfo: TicketApplicationBaseInfoProps = {
  orderHash: '',
};
